import { BucketVendors } from "../app/enums/bucketVendors.enum";

const environmentObject = {
	production: false,
	videoOriginalUrl:"https://arla-original-videos.s3.us-east-1.amazonaws.com",
	videoTranscodedUrl:"https://arla-transcoded-videos.s3.us-east-1.amazonaws.com",
	videoCloudOriginalUrl:"https://d2nrmnfm4j21di.cloudfront.net",
	videoCloudTranscodedUrl:"https://d1bqvgtucg6zhy.cloudfront.net",
	subtitleS3Domain: "videos-with-subtitles.s3.amazonaws.com",
	subtitleCdnDomain: "d1bqvgtucg6zhy.cloudfront.net",
	firebase: {
		apiKey: "AIzaSyBUdP2Ix2N0zLCR1CuS-oI6O-3jP2jiqoY",
		authDomain: "arla-cms-dev.firebaseapp.com",
		projectId: "arla-cms-dev",
		storageBucket: "arla-cms-dev.appspot.com",
		messagingSenderId: "462992164828",
		appId: "1:462992164828:web:27448ba9996c0db621f119",
		stylesURL: '/themes/styles.css',
		databaseURL: "https://arla-cms-dev-default-rtdb.firebaseio.com"
	},
	translations: {
		prefix: 'https://firebasestorage.googleapis.com/v0/b/arla-cms-dev.appspot.com/o/projects%2FbiojewJGMWrIV7r3jcI9%2Flang-json%2F',
		suffix: '.json?alt=media',
	},
	API_URL: 'https://us-central1-arla-cms-dev.cloudfunctions.net',
	projectId: 'biojewJGMWrIV7r3jcI9',
	fileImageSize: 5,
	minWidthResponsive: 576,
	loginImage: "https://firebasestorage.googleapis.com/v0/b/arla-cms-dev.appspot.com/o/projects%2FbiojewJGMWrIV7r3jcI9%2Fthemes%2Flogin-image.jpeg?alt=media&token=548167a9-8f96-406b-8ce2-ce7011e176d4",
	stylesUrl: "https://firebasestorage.googleapis.com/v0/b/arla-cms-dev.appspot.com/o/projects%2FbiojewJGMWrIV7r3jcI9%2Fthemes%2Fstyles.css?alt=media&token=58793a8c-bae5-4ea4-9e5f-66712bc94028",
	hostName: 'https://hhau.staging.arla.ai',
	favicon: "https://firebasestorage.googleapis.com/v0/b/arla-cms-dev.appspot.com/o/projects%2FbiojewJGMWrIV7r3jcI9%2Fthemes%2Ffavicon.png?alt=media&token=910a64e7-b41f-413c-a674-ca40864d5a81",
	pdfPlaceholderImage: "https://firebasestorage.googleapis.com/v0/b/arla-cms-dev.appspot.com/o/projects%2FbiojewJGMWrIV7r3jcI9%2Fthemes%2Fpdf_thumbnail.jpg?alt=media&token=5f94ee72-5c37-4f44-8ab6-8cae2b75be39",
	manage: {
		students: {
			dateFilterField: '',
			defaultOrderBy: "username",
			defaultOrderDirection: "asc",
			searchOrderBy: "username",
			table: {
				columns: [
					{ label: 'general.user', field: 'username' },
					{ label: 'general.email', field: 'email' },
					{ label: 'general.status', field: 'status', templateName: 'status' },
					{ label: 'general.account_expiration', field: 'expirationDate', templateName: 'expirationDate' },
				]
			}
		}
	},
	sales: {
		userCategory : {
			dateFilterField: "created_at",
			defaultOrderBy: "created_at",
			defaultOrderDirection: "desc",
			table: {
				columns: [
					{ label: 'sales.product', field: 'categoryName'},
					{ label: 'sales.student', field: 'userFullName', templateName: 'fullNameTemplate'  },
					{ label: 'sales.date', field: 'createdAt', templateName: "dateTemplate"},
					{ label: 'sales.amount', field: 'price', templateName: "amountTemplate"},
				]
			}
		},
		categoryStatistics : {
			dateFilterField: "quantity",
			defaultOrderBy: "quantity",
			defaultOrderDirection: "desc",
			table: {
				columns: [
					{ label: 'sales.product', field: 'categoryName' },
					{ label: 'general.sales', field: 'quantity' },
					{ label: 'sales.earnings', field: 'amount', templateName : 'amountTemplate'},
				]
			}
		},
		orders : {
			dateFilterField: "created_at",
			defaultOrderBy: "created_at",
			defaultOrderDirection: "desc",
			table: {
				columns: [
					{ label: 'sales.order', field: 'id', templateName: 'orderIdTemplate' },
					{ label: 'sales.products', field: 'products', templateName: 'productsTemplate' },
					{ label: 'sales.amount', field: 'totalAmount' },
					{ label: 'sales.date', field: 'date', templateName : 'dateTemplate' },
					{ label: 'sales.state', field: 'state', templateName : 'purchaseStateTemplate' },
				]
			}
		},
	},
	pricing: {
		currency: {
			allowSelection: false,
			defaultValue: 'USD'
		},
		min: 1,
		max: 1000000
	},
	fileVideoSize: 1000000000,
	bucket: {
		vendor: BucketVendors.AWS,
		config: {
			region: "us-east-1"
		},
		originalName: "arla-original-videos",
	},
	sentry: {
		dns: "https://3952f79d82093a063ceddaca2308e8b7@o1245196.ingest.us.sentry.io/4509729645854720",
		env: "development-arla",
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0
	},
	TAWK_TO_KEY: 'https://embed.tawk.to/682ce1466392a3190c782648/1irnkvuoj',
	paypal: {
		clientId: '',
		baseUrl: ''
	}
};

export const environment: Partial<typeof environmentObject> & { [key: string]: any } = environmentObject;
